import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <header className="relative min-h-screen flex items-center justify-center py-20 px-4 overflow-hidden bg-navy-900" data-id="element-107">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-108">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-navy-800 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob" data-id="element-109" />
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-gold-600 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-blob animation-delay-2000" data-id="element-110" />
      </div>

      <div className="relative max-w-6xl mx-auto w-full grid md:grid-cols-2 gap-12 items-center" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-left space-y-8" data-id="element-112">
          <div className="space-y-4" data-id="element-113">
            <motion.span initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="inline-block text-gold-400 font-medium tracking-wider uppercase text-sm" data-id="element-114">
              For Women 40+
            </motion.span>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-medium leading-tight text-cream-50" data-id="element-115">
              Stop the <br data-id="element-116" />
              <span className="text-gold-400 italic" data-id="element-117">2–4am spiral.</span>
            </h1>
            <p className="text-xl md:text-2xl text-cream-100/80 font-light max-w-lg" data-id="element-118">
              A 4-step night routine to reclaim your sleep without medication or
              woo.
            </p>
          </div>

          <div className="space-y-6" data-id="element-119">
            <p className="text-lg text-cream-100/70 leading-relaxed" data-id="element-120">
              You're exhausted all day. But the second your head hits the
              pillow… your brain acts like it's clocking in for a night shift.
              It's time to close the loop.
            </p>
            <Button onClick={() => document.getElementById('cta')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-121">
              Get The Blueprint
            </Button>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="relative" data-id="element-122">
          <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl shadow-navy-900/50 border border-navy-700/50" data-id="element-123">
            <img src="https://cdn.magicpatterns.com/uploads/mfqfXaKRYQJ4YL4gL3QDLb/producto_digtial_402B.png" alt="The Sleep & Serenity Blueprint on a tablet in a cozy bedroom setting" className="w-full h-auto object-cover" data-id="element-124" />
          </div>
          {/* Decorative ring */}
          <div className="absolute -inset-4 border border-gold-500/20 rounded-3xl z-0" data-id="element-125" />
        </motion.div>
      </div>
    </header>;
}